import React from 'react';

import { RetailSurveySlide } from '../components/retail-slides/RetailSurveySlide';
import {
  RetailFirstSlideHeader,
  RetailFourthSlideHeader,
  RetailSecondSlideHeader,
  RetailSlidesFirst,
  RetailSlidesFourth,
  RetailSlidesSecond,
  RetailSlidesThird,
  RetailSurveyHeader,
  RetailThirdSlideHeader,
} from '../components/retail-slides/slide-wrapper/SlideWrapper';
import {
  ConsumerFirstSlideHeader,
  ConsumerFourthSlideHeader,
  ConsumerQualtricsSlideHeader,
  ConsumerSecondSlideHeader,
  ConsumerSlidesFirst,
  ConsumerSlidesFourth,
  ConsumerSlidesSecond,
  ConsumerSlidesThird,
  ConsumerStoriesQualtricsSlide,
  ConsumerStoriesRLSQualtricsSlide,
  ConsumerThirdSlideHeader,
  MarketQualtricsSlide,
  ResellerTrendsSlide,
} from '../components/slides';

export enum Product {
  Consumer = 'Consumer',
  Retail = 'Retail',
  Predict = 'Predict',
  Market = 'Market',
  Market4x = 'Market Basic 4x',
  Market6x = 'Market Basic 6x',
}
export const ProductMapping = {
  [Product.Market4x]: 'market_basic_4x',
  [Product.Market6x]: 'market_basic_6x',
};

export const SyntheticUsers = [
  'sre-ui-synthetic-user@nipkn5gl.mailosaur.net',
  'ui-synthetic-test-client-user-1@gfk.com',
  'ui-synthetic-test-notification-user@nipkn5gl.mailosaur.net',
  'cie-synthetic-test-user-1@gfk.com',
  'market-synthetic-test-user-1@gfk.com',
];

export const E2ETestUsers = [
  'ecosystem-test-in-dev@gfk.com',
  'ecosystem-terms-test-in-dev@gfk.com',
  'searchUser-test@mail.com',
  'pos-test-user-1-dev@mail.com',
  'pos-test-user-2-dev@mail.com',
  'pos-test-user-4-dev@mail.com',
  'dyson-jp-test-user-1@mail.com',
  'many-user-brands-dev-1@gfk.com',
  'many-user-brands-dev-2@gfk.com',
  'many-user-brands-dev-4@gfk.com',
  'cie-only-user2@gfk.com',
  'blocked-user-dev@gfk.com',
  'luna-test-user-1@gfk.com',
  'luna-test-user-2@gfk.com',
  'luna-test-user-4@gfk.com',
  'model-group-test-e2e@gee-eff-kay.com',
  'user1-test-subsc-outlet@gfk.com',
  'client3.newron-test@gfk.com',
  'e2e-email-notification-user@nipkn5gl.mailosaur.net',
  'e2e-push-notification-test-user@nipkn5gl.mailosaur.net',
  'smoke-test-user-1-dev@gfk.com',
  'searchuser-test-stable@gfk.com',
  'searchUser-test@gfk.com',
  'pref-service-dev@gfk-test.com',
  'pref-service-stable@gfk-test.com',
  'pref-nest-api-pipeline@gfk-test.com',
  'dev_user1_invitationEnabled@gfk.com',
  'dev_user2_invitationDisabled@gfk.com',
  'gfkdev@mailinator.com',
  'model-group-test-e2e-stable@gee-eff-kay.com',
  'notifications-user-1@qkxdwtqm.mailosaur.net',
  'notifications-user-2@qkxdwtqm.mailosaur.net',
  'ab_test2022@sharing.com',
  'ab_test-stable@sharing.com',
  'gh_test2022@sharing.com',
  'gh_test-stable@sharing.com',
  'pos-test-user-1-stable@gee-eff-kay.com',
  'shareview@gee-eff-kay.com',
  'shareview-stable@gee-eff-kay.com',
  'shareview2@gee-eff-kay.com',
  'shareview2-stable@gee-eff-kay.com',
  'shareview3@gee-eff-kay.com',
  'shareview3-stable@gee-eff-kay.com',
  'e2e-test-onboarding-all@qkxdwtqm.mailosaur.net',
  'e2e-test-onboarding-retail@qkxdwtqm.mailosaur.net',
  'super-admin-test-1@mail.com',
  'sales-admin-test-user-1@gfk.com',
  'client-admin-test-user-1@gfk.com',
  'market-admin-test-user-1@gfk.com',
  'market.configurator.test2.user@gfk.com',
  'ui-synthetic-test-client-user-1@gfk.com',
  'ui-synthetic-test-notification-user@nipkn5gl.mailosaur.net',
  'notification-preference-user-dev@gfk.com',
  'notification-preference-user-stable@gfk.com',
  'e2e-shared-filter-email@nipkn5gl.mailosaur.net',
  'e2e-filter-email-user-dev@nipkn5gl.mailosaur.net',
  'e2e-filter-email-user-stable@nipkn5gl.mailosaur.net',
  'e2e-filter-sender-dev@gfk.com',
  'e2e-filter-sender-stable@gfk.com',
  'market.configurator.test.user@gfk.com',
  'user4manybrands2@nipkn5gl.mailosaur.net',
  'copy-link-test-in-dev-2@gfk.com',
  'copy-link-test-in-stable-2@gfk.com',
  'e2e-test-data-access-split@qkxdwtqm.mailosaur.net',
  'e2e-test-data-access-split-user@qkxdwtqm.mailosaur.net',
  'e2e-forecasting-tallest-test-user@gfk.com',
  'ecosystem-test-in-prod@gfk.com',
  'predict-lite-e2e-dev@serpens.com',
  'predict-lite-e2e-stable@serpens.com',
  'onboarding_retail_market_dev@gfk.com',
  'analytics-user-1@any.com',
  'generic_e2e_user@gfk.com',
  'generic_e2e_user_stable@gfk.com',
  'tradeBrandsMarket@gfk.com',
  'tradeBrandsPredict@gfk.com',
  'market-eco@qkxdwtqm.mailosaur.net',
  'accesssplituser2@nipkn5gl.mailosaur.net',
  'e2e-test-das-globsum-user@qkxdwtqm.mailosaur.net',
  'ple-compliance-test-in-prod@nipkn5gl.mailosaur.net',
  'nps-survey-e2e-user-stable@nipkn5gl.mailosaur.net',
  'nps-survey-e2e-user-dev@nipkn5gl.mailosaur.net',
  'market-periods-e2e-u2@qkxdwtqm.mailosaur.net',
  'e2e-test-access-modules-split-bc-dev@qkxdwtqm.mailosaur.net',
  'e2e-test-access-modules-split-bc-stable@qkxdwtqm.mailosaur.net',
  'ple_tester@gfk.com',
  'ple_tester_nz1@gfk.com',
  'e2e-test-predict-split-dev@qkxdwtqm.mailosaur.net',
  'e2e-test-predict-split-stable@qkxdwtqm.mailosaur.net',
  'competitors-matrix-e2e@nipkn5gl.mailosaur.net',
];

export const ShowSliderButtonId = 'show-slider-button-id';

export const ProdishAuth0Domain = 'auth.gfk.com';
export const NonProdishAuth0Domain = 'auth-dev.gfk.com';

export enum Clients {
  EXAMPLE_CLIENT = 'Example client',

  // CONSUMER_LOST_SHOPPER test dev - 180607
  ConsumerLostShopperDevUpsell = 'ConsumerLostShopperDevUpsell',
  // CONSUMER_LOST_SHOPPER test stable - 21880
  ConsumerLostShopperStablUpsell = 'ConsumerLostShopperStablUpsell',
  // CONSUMER_RETAIL_LOST_SHOPPER test dev - 184207
  ConsumerRetailLostShopperDevUpsell = 'Upsell_CS_RLS_DEV',
  // CONSUMER_RETAIL_LOST_SHOPPER test stable - 23042
  ConsumerRetailLostShopperStableUpsell = 'Upsell_CS_RLS_STABLE',

  // Target ALL Retail clients for CONSUMER_RETAIL_LOST_SHOPPER campaign
  RetailClient = 'RetailClient',

  // Test clients
  ZOZOMI = 'zozomi', // prod test client
  AAAATEST = 'AAAATest', // dev test client
  PerformancePulseTestClient = 'PerformancePulseTestClient', // stable test client
}

export enum Cell {
  ExampleMarketWithCountry = 'EXAMPLE_MARKET/DE',
}

export enum SlidesByType {
  DEFAULT = 'DEFAULT',
  CONSUMER_LOST_SHOPPER = 'CONSUMER_LOST_SHOPPER',
  CONSUMER_RETAIL_LOST_SHOPPER = 'CONSUMER_RETAIL_LOST_SHOPPER',
  RETAIL_KAD = 'RETAIL_KAD',
}

export const CONSUMER_LOST_SHOPPER_SLIDES = [
  {
    headline: <ConsumerFirstSlideHeader />,
    component: ConsumerSlidesFirst,
  },
  {
    headline: <ConsumerSecondSlideHeader />,
    component: ConsumerSlidesSecond,
  },
  {
    headline: <ConsumerThirdSlideHeader />,
    component: ConsumerSlidesThird,
  },
  {
    headline: <ConsumerFourthSlideHeader />,
    component: ConsumerSlidesFourth,
  },
  {
    headline: <ConsumerQualtricsSlideHeader />,
    component: ConsumerStoriesQualtricsSlide,
  },
];

export const CONSUMER_RETAIL_LOST_SHOPPER_SLIDES = [
  {
    headline: '',
    component: ConsumerStoriesRLSQualtricsSlide,
  },
];

export const MARKET_SLIDES = [
  {
    headline: '',
    component: ResellerTrendsSlide,
  },
  {
    headline: '',
    component: MarketQualtricsSlide,
  },
];

export type PageDetailsSelector = {
  wait: string;
  show: string;
  name?: string;
};

export type PageDetails = {
  selectors: PageDetailsSelector[];
  name?: PageName;
};

export enum ElementSelector {
  HEADER_SELECTOR = 'header#newron-header',
  BRAND_LEADERBOARD_SELECTOR = 'h1.BrandsSummaryPage__Heading',
  PRODUCTS_LEADERBOARD_SELECTOR = 'h1.ProductsSummaryPage__Heading',
  OVERVIEW_CHART_SELECTOR = '#PerformanceTrendChart div.graph',
  SEGMENTATION_PAGE_SELECTOR = 'h1[data-test-id="segmentation-header"]',
  RETAILER_OVERVIEW_PAGE_SELECTOR = 'h1[class^="Overview_Overview__Title"]',
  RETAILER_CATEGORY_LEADERBOARD_PAGE_SELECTOR = 'h1[class^="CategoryLeaderboard_Summary__Title"]',
  RETAILER_OPPORTUNITY_REVIEW_PAGE_SELECTOR = 'h1[class^="OpportunityReview_OpportunityReview__Title"]',
  RETAILER_PERFORMANCE_ANALYSIS_PAGE_SELECTOR = 'h1[class^="PerformanceAnalysis_PerformanceAnalysis__Title"]',
  RETAILER_TRADING_ASSISTANT_PAGE_SELECTOR = 'h1[class^="TradingAssistant_TradingAssistant__Title"]',
  RETAILER_PRODUCT_ANALYZER_PAGE_SELECTOR = 'h1[class^="ProductAnalyzer-module__ProductAnalyzer__Title"]',
}

export enum PageName {
  OVERVIEW = 'Overview',
  BRANDS_LEADERBOARD = 'Brands Leaderboard',
  PRODUCTS_LEADERBOARD = 'Products Leaderboard',
  SEGMENTATION = 'Segmentation',
  RETAILER_OVERVIEW = 'Retailer Overview',
  RETAILER_CATEGORY_LEADERBOARD = 'Retailer Category Leaderboard',
  RETAILER_OPPORTUNITY_REVIEW = 'Retailer Opportunity Review',
  RETAILER_PERFORMANCE_ANALYSIS = 'Retailer Performance Analysis',
  RETAILER_TRADING_ASSISTANT = 'Retailer Trading Assistant',
  RETAILER_PRODUCT_ANALYZER = 'Retailer Products',
}

export const BRAND_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.BRAND_LEADERBOARD_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.BRANDS_LEADERBOARD,
};
export const PRODUCTS_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.PRODUCTS_LEADERBOARD_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.PRODUCTS_LEADERBOARD,
};
export const OVERVIEW_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.OVERVIEW_CHART_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.OVERVIEW,
};
export const SEGMENTATION_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.SEGMENTATION_PAGE_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.SEGMENTATION,
};
export const RETAILER_OVERVIEW_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.RETAILER_OVERVIEW_PAGE_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.RETAILER_OVERVIEW,
};
export const RETAILER_CATEGORY_LEADERBOARD_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.RETAILER_CATEGORY_LEADERBOARD_PAGE_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.RETAILER_CATEGORY_LEADERBOARD,
};
export const RETAILER_OPPORTUNITY_REVIEW_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.RETAILER_OPPORTUNITY_REVIEW_PAGE_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.RETAILER_OPPORTUNITY_REVIEW,
};
export const RETAILER_PERFORMANCE_ANALYSIS_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.RETAILER_PERFORMANCE_ANALYSIS_PAGE_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.RETAILER_PERFORMANCE_ANALYSIS,
};
export const RETAILER_TRADING_ASSISTANT_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.RETAILER_TRADING_ASSISTANT_PAGE_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.RETAILER_TRADING_ASSISTANT,
};
export const RETAILER_PRODUCT_ANALYZER_PAGE_DETAILS: PageDetails = {
  selectors: [
    {
      wait: ElementSelector.RETAILER_PRODUCT_ANALYZER_PAGE_SELECTOR,
      show: ElementSelector.HEADER_SELECTOR,
    },
  ],
  name: PageName.RETAILER_PRODUCT_ANALYZER,
};

export const UpsellConstants = {
  ToastMessageSuccess: 'Thank you for your request. We will be in touch with more information.',
  ToastMessageError: 'Something went wrong. Please try again later.',
};

export enum TargetedUpsellTrackingEvents {
  SHOWN = 'targeted-upsell-shown',
  REJECTED = 'targeted-upsell-rejected',
  ACTIVATED = 'targeted-upsell-activated',
  DECLINED = 'targeted-upsell-declined',
}

export const QualtricsWorkflowIds = {
  NORMAL_UPSELL: '249c3df0-27c3-47ad-9851-2d96312e05d5',
  TARGETED_UPSELL: 'c607a9bd-a1f0-47f9-a1c7-059495485e82',
  RETAIL_KAD_UPSELL: '45259f21-dda3-4836-b4bb-4097db279726',
};

export enum UpsellName {
  MONTHLY_INSIGHTS = 'monthly_data_insight_upsell',
  RETAIL_KAD = 'retail_kad_upsell',
  MONTHLY_DATA = 'monthly_data_notification_upsell',
}

export enum UpsellStatus {
  UPSELL_SHOWN = 'upsell-shown',
  UPSELL_ACTIVATED = 'upsell-activated',
  UPSELL_DECLINED = 'upsell-declined',
  UPSELL_INFO = 'upsell-info',
  UPSELL_ENGAGED = 'upsell-engaged',
}

export const TargetedUpsellHeading = {
  condition1: 'Significant market uplift in ',
  condition2: 'Leading brand sees gains in ',
  bothConditions: 'Leading brand makes gains in ',
};

export const TargetedUpsellBody = {
  condition1:
    'Identify areas of growth and capitalize on them by upgrading your access to the latest Market data. Click below to request your account manager to reach out by phone or email. ',
  condition2:
    'Don’t miss out and increase your sales by enhancing your access to receive latest Market data. Click below to request your account manager to reach out by phone or email.',
  bothConditions:
    'Identify areas of growth and capitalize on them by upgrading your access to the latest Market data. Click below to request your account manager to reach out by phone or email. ',
};
export enum AlertType {
  Success = 'success',
  Error = 'error',
  Warn = 'warn',
  Info = 'info',
}

export const RETAIL_KAD_SLIDES = [
  {
    headline: <RetailFirstSlideHeader />,
    component: RetailSlidesFirst,
  },
  {
    headline: <RetailSecondSlideHeader />,
    component: RetailSlidesSecond,
  },
  {
    headline: <RetailThirdSlideHeader />,
    component: RetailSlidesThird,
  },
  {
    headline: <RetailFourthSlideHeader />,
    component: RetailSlidesFourth,
  },
  {
    headline: <RetailSurveyHeader />,
    component: RetailSurveySlide,
  },
];

export enum UpsellType {
  MONTHLY_INSIGHTS_UPSELL = 'monthly_data_insight_upsell',
  RETAIL_KAD_UPSELL = 'retail_kad_upsell',
}

//intermediary map to disable Retail KAD upsell, means to an end for a full fledged rule engine
export const UpsellPriorities = new Map<UpsellType, number>([
  [UpsellType.MONTHLY_INSIGHTS_UPSELL, 1],
  [UpsellType.RETAIL_KAD_UPSELL, 0],
]);
